import CloseIcon from "@mui/icons-material/Close";
import { Box, Button, Dialog } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { convertDateTimeSimple } from "../../utils/utils";
import useStyles from "./caught.styles";

import timeImg from "../../assets/imgs/crime/clockwise.png";
import mafiaImg from "../../assets/imgs/crime/criminal.png";
import logoImg from "../../assets/imgs/crime/siren.png";

interface NickCarCaughtPopupProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const NickCarCaughtPopup: React.FC<NickCarCaughtPopupProps> = ({
  openModal,
  setOpenModal,
}) => {
  const { classes } = useStyles();
  const navigate = useNavigate();

  const [remainTime, setRemainTime] = useState(45 * 60);

  const handleClose = () => {
    setOpenModal(false);

    navigate("/injail");
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setRemainTime((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <Dialog open={openModal} onClose={handleClose} className={classes.body}>
      <Box className={classes.modalContent}>
        <Box className={classes.closeIconBody}>
          <Button onClick={handleClose}>
            <CloseIcon htmlColor="gray" />
          </Button>
        </Box>

        <Box className={classes.contentBody}>
          <Box component={"img"} src={logoImg} className={classes.logoImg} />
          <Box className={classes.titleText}>You got caught!</Box>
          <Box component={"img"} src={mafiaImg} className={classes.mafiaImg} />
          <Box className={classes.tryAgainText}>
            You are in jail for the next
          </Box>
          <Box className={classes.remainTimeBox}>
            <Box component={"img"} src={timeImg} className={classes.clockImg} />
            <Box className={classes.remainTime}>
              {convertDateTimeSimple(remainTime)}
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default NickCarCaughtPopup;
